























































import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { AdminDTO } from '../../../src_server/entity/dto/AdminDTO';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { MessageDialog } from '../../utils/MessageDialog';
import { AdminService } from '../../biz/remote/AdminService';
import { buildingOptions } from '../../../src_server/entity/master/buildingData';
import { adminUserTypeOptions } from '../../../src_server/entity/master/UserType';
import SimpleSelect from '../../components/inputs/SimpleSelect.vue';

@Component({
  components: {
    CommonDialog,
    SimpleSelect,
  },
})
export default class AdminInfoMaintenance extends Vue {
  private type: 'add' | 'detail' = 'detail';
  private info: AdminDTO = new AdminDTO();

  private userId = '';
  private userType = '';
  private password = '';
  private builidingId = '';
  private userName = '';
  private email = '';

  get buildings() {
    return buildingOptions;
  }
  get userTypes() {
    return adminUserTypeOptions;
  }
  get isDetail() {
    return this.type === 'detail';
  }

  /**
   * 詳細ボタンのイベントハンドラ
   */
  public show(row: AdminDTO, type: 'add' | 'detail') {
    this.info = row;

    this.type = type;
    this.userId = row.userAuth.user_id || '';
    this.userType = row.userAuth.user_type || '';
    this.password = '';
    this.builidingId = row.building_id || '';
    this.userName = row.userAuth.user_name || '';
    this.email = row.userAuth.email || '';

    const dialog = this.$refs['admin_detail_dialog'] as CommonDialog;
    dialog.show();
  }

  hide() {
    const dialog = this.$refs['admin_detail_dialog'] as CommonDialog;
    dialog.hide();
  }

  async add() {
    const isOK = await MessageDialog.confirm(`${this.userName}さんのデータを追加します。よろしいですか？`);
    if (isOK) {
      const biz = new AdminService();
      const result = await biz.addAdminUsers(this.builidingId, this.userName, this.email, this.password, this.userType);
      if (result.hasError) {
        await MessageDialog.alert(result.errorDescription);
        this.hide();
        return;
      }
      const resultInfo = result.data;
      const user_id = resultInfo.userAuth.user_id;
      if (!user_id) {
        await MessageDialog.systemError('ユーザーID', 'メンテナンス登録時', user_id);
        return;
      }

      this.$emit('added', resultInfo);
      this.hide();
    }
  }

  // async update() {
  //   const user_id = this.userId;
  //   if (!user_id) {
  //     await MessageDialog.systemError('ユーザーID', 'メンテナンス更新時', user_id);
  //     return;
  //   }
  //   const biz = new AdminService();
  //   const updateResult = await biz.maintenanceUpdate(user_id, this.info);
  //   const updateResultInfo = updateResult.data;

  //   this.hide();
  //   this.$emit('updated', updateResultInfo);
  // }

  async deleteComplete() {
    if (!this.userId) {
      await MessageDialog.systemError('ユーザーID', '完全削除', this.userId);
      return;
    }
    const isOK = await MessageDialog.confirm(`${this.info.userAuth.user_name}/${this.info.userAuth.user_name}さんのデータを完全に削除します。この処理は戻せません。よろしいですか？`);
    if (isOK) {
      const biz = new AdminService();
      await biz.completeDelete(this.info.userAuth.user_id!, this.info.building_id);
      this.$emit('deleted', this.info.userAuth.user_id);
      this.hide();
    }
  }
}
